// eslint-disable-next-line import/prefer-default-export
export enum PopupMessageType {
  yandexOAuthSuccess,
  yandexOAuthError,
  vkOAuthSuccess,
  vkOAuthError,
}
